(function () {
  'use strict';

  var sectionEl = document.querySelector('[data-marla-ajax-section]');
  if (!sectionEl) return;

  var sectionId = sectionEl.dataset.marlaAjaxSection;
  var innerEl   = sectionEl.querySelector('[data-marla-grid-inner]');
  if (!innerEl) return;

  var cache   = {};
  var pending = false;

  function buildFetchUrl(url) {
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);
  }

  function fetchAndRender(url) {
    if (pending) return;
    pending = true;
    innerEl.classList.add('is-loading');

    if (cache[url]) {
      renderHtml(cache[url], url);
      return;
    }

    fetch(buildFetchUrl(url))
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) throw new Error('no section html');
        cache[url] = html;
        renderHtml(html, url);
      })
      .catch(function () {
        pending = false;
        innerEl.classList.remove('is-loading');
        location.href = url;
      });
  }

  function renderHtml(html, url) {
    var parser   = new DOMParser();
    var doc      = parser.parseFromString(html, 'text/html');
    var newInner = doc.querySelector('[data-marla-grid-inner]');
    if (newInner) {
      innerEl.innerHTML = newInner.innerHTML;
    }
    // Release scroll lock set when filter drawer was opened
    document.body.style.overflow = '';
    history.pushState({ path: url }, '', url);
    innerEl.classList.remove('is-loading');
    pending = false;
  }

  // Intercept filter + sort clicks — capture phase runs before snippet handlers
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.marla-fd-option, .marla-fd-clear');
    if (link && link.tagName === 'A') {
      e.preventDefault();
      e.stopPropagation();
      fetchAndRender(link.href);
      return;
    }
    var sortOpt = e.target.closest('[data-sort-url]');
    if (sortOpt) {
      e.preventDefault();
      e.stopPropagation();
      fetchAndRender(sortOpt.dataset.sortUrl);
    }
  }, true);

  // Accordion toggle — delegation survives DOM swaps after re-render
  document.addEventListener('click', function (e) {
    var header = e.target.closest('[data-marla-fd-group-toggle]');
    if (!header) return;
    var group  = header.closest('[data-marla-fd-group]');
    var body   = group.querySelector('.marla-fd-group__body');
    var isOpen = !body.hidden;
    body.hidden = isOpen;
    header.setAttribute('aria-expanded', String(!isOpen));
    header.querySelector('.marla-fd-group__chevron').textContent = isOpen ? '+' : '−';
  });

  // Browser back / forward
  window.addEventListener('popstate', function () {
    fetchAndRender(location.href);
  });

})();
